import { AbstractControl } from '@angular/forms';
import { parsePhoneNumberWithError } from 'libphonenumber-js';

/**
 * Errors obtained from `libphonenumber-js > API > parsePhoneNumberFromString` just before the very end of that section
 * there is a `possible errors` section
 * https://www.npmjs.com/package/libphonenumber-js#:~:text=else%20%7B%0A%20%20%20%20throw%20error%0A%20%20%7D%0A%7D-,Possible,-errors
 */
enum PhoneNumberErrors {
  INVALID_COUNTRY = 'The selected country is not supported',
  NOT_A_NUMBER = 'Phone number is invalid',
  TOO_LONG = 'The phone number provided is too long',
  TOO_SHORT = 'The phone number provided is too short'
}

export class PhoneNumberValidator {
  static Validate(control: AbstractControl) {
    const countryCodeInput = control.get('country_code');
    const phoneNumberInput = control.get('phone_number');

    // If we don't get a `country_code` or a `phone_number`, we return earlier and not perform any kind of validation
    if (countryCodeInput === null || !countryCodeInput.value || !phoneNumberInput.value) {
      return;
    }

    let response;
    const phoneNumber = phoneNumberInput.value;
    const countryCode = countryCodeInput.value;
    try {
      const parsedPhoneNumber = parsePhoneNumberWithError(phoneNumber, countryCode.twoLetterCode.toUpperCase());

      // If we get an invalid number, return a `value` key because `field-errors.component` defaults to display `value` from `error` object
      response = parsedPhoneNumber.isPossible() ? null : { value: 'Phone number is invalid' };
    } catch (e) {
      console.error('An error occurred when parsing phone number:', e);
      response = { value: PhoneNumberErrors[e.message] };
    } finally {
      phoneNumberInput.setErrors(response);
    }
  }

  static ValidateFax(control: AbstractControl) {
    const countryCodeInput = control.get('country_code');
    const phoneNumberInput = control.get('fax');

    // If we don't get a `country_code` or a `phone_number`, we return earlier and not perform any kind of validation
    if (countryCodeInput === null || !countryCodeInput.value || !phoneNumberInput.value) {
      return;
    }

    let response;
    const phoneNumber = phoneNumberInput.value;
    const countryCode = countryCodeInput.value;
    try {
      const parsedPhoneNumber = parsePhoneNumberWithError(phoneNumber, countryCode.twoLetterCode.toUpperCase());

      // If we get an invalid number, return a `value` key because `field-errors.component` defaults to display `value` from `error` object
      response = parsedPhoneNumber.isPossible() ? null : { value: 'Fax number is invalid' };
    } catch (e) {
      console.error('An error occurred when parsing fax number:', e);
      response = { value: PhoneNumberErrors[e.message] };
    } finally {
      phoneNumberInput.setErrors(response);
    }
  }
}
